module.exports = __webpack_public_path__ + "static/wp-rocket-b45aab890d5a7eb6e1c397d1a1a387de.png";